import { Separator } from '@/components/ui/Separator';
import { cn } from '@/lib/utils';

import { useInObject } from '../internals/objectContext';
import { sizingClass } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

// Inside the object the document's gaps alone space the footer hairline
export const Divider: ComponentFn<typeof catalog, 'Divider'> = ({ props }) => {
  const inObject = useInObject();
  return (
    <Separator
      className={cn(
        'bg-border-subtle',
        inObject ? 'my-0' : 'my-[calc(2*var(--ac-u))]',
        sizingClass(props.sizing)
      )}
    />
  );
};
